<div class="modal-header">
  <span>
    <h4 class="h2Header" id="modal-basic-title" name="selectrole">Select Role</h4>
  </span>
  <span>
    <button type="button" class="close" (click)="onNoClick()" [ngStyle]="{ outline: '0' }" name="close">
      <span aria-hidden="true">×</span>
    </button>
  </span>
</div>

<div class="modal-body">
  <mat-form-field id="roleSelectionParentId">
    <mat-label name="selectrolelabel">Please Select Role</mat-label>
    <mat-select [(ngModel)]="selectedRole" (ngModelChange)="onSelect()" id="roleSelect">
      <mat-option *ngFor="let item of data; let i = index" [value]="item.roleName" id="selectdropdown{{ i }}">
        {{ item.roleDesc }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field class="marL32" id="hiringTypeSelectionParentId" *ngIf="selectedRole !== ''">
    <mat-label name="selectCompanylabel">Please Select Company Hiring Type</mat-label>
    <mat-select [(ngModel)]="selectedContext" (ngModelChange)="onSelectCompHiringType()" id="companySelect">
      <mat-option
        *ngFor="let item of contextKeyValue | keyvalue; let i = index"
        [value]="item.key"
        id="selectdropdown1{{ i }}"
      >
        {{ item.value }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>

<div class="modal-footer">
  <div>
    <div class="row nomarLR padTB16">
      <div class="col-6 padR8">
        <button
          mat-flat-button
          class="primary-btn"
          id="roleSelectBtn"
          [disabled]="selectedContext === ''"
          (click)="onRoleSelect()"
          [class.phase-active]="activeButton === 1"
          style="width: 110px; margin-right: 15px"
          name="selectbutton"
        >
          Select
        </button>
      </div>
      <div class="col-6 padL8">
        <button
          mat-flat-button
          class="secondary-btn"
          id="roleSelectCancelBtn"
          (click)="showPhase(2)"
          [class.phase-active]="activeButton === 2"
          (click)="onNoClick()"
          name="cancelbutton"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
</div>
